import { z } from 'zod';
import { FeedEnvelopeSchema } from './envelope.js';
import { PROTOCOL_VERSION } from './events.js';
/**
 * Session recording format: one JSONL file per session.
 *
 * Line 1 is the header; every subsequent line is an envelope with its offset
 * from session start. Recording happens at the protocol layer, which is the
 * whole point of the harness — a replay drives the identical server code path a
 * live game does, so every phase after this one is testable without League
 * running.
 */
export const RecordingHeaderSchema = z.object({
    kind: z.literal('header'),
    v: z.literal(PROTOCOL_VERSION),
    sessionId: z.string().min(1),
    startedAt: z.number().int().nonnegative(),
    agentVersion: z.string(),
    machine: z.string(),
    note: z.string().default(''),
});
export const RecordingEntrySchema = z.object({
    kind: z.literal('env'),
    /** Milliseconds since session start — drives replay scheduling. */
    tOffsetMs: z.number().int().nonnegative(),
    envelope: FeedEnvelopeSchema,
});
export const RecordingLineSchema = z.discriminatedUnion('kind', [
    RecordingHeaderSchema,
    RecordingEntrySchema,
]);
//# sourceMappingURL=recording.js.map